import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';

const BreadcrumbContainer = ({ items }) => {

  const route = [{ title: <Link to='/'>Inicio</Link> }]
    .concat(items.map(item => ({ title: (item.to ? <Link to={item.to}>{item.text}</Link> : item.text), })));

  return (
    <Breadcrumb style={{marginBottom:20}} separator='>' items={route} />
  );
};

export default BreadcrumbContainer;
